var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewsletter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2511",
    "data-name": "Rectangle 2511",
    width: 24,
    height: 24,
    transform: "translate(19 112)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4743",
    "data-name": "Mask Group 4743",
    transform: "translate(-19 -112)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Newspaper",
    transform: "translate(1.417 59.879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6111",
    "data-name": "Group 6111",
    transform: "translate(20 56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7307",
    "data-name": "Path 7307",
    d: "M26.5,62.5H24.874a1.625,1.625,0,0,0-1.625,1.625v6.5a1.625,1.625,0,0,0,3.25,0V59.25a3.25,3.25,0,1,0-6.5,0v8.124A1.625,1.625,0,0,0,21.625,69H23.25",
    transform: "translate(-20 -56)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7308",
    "data-name": "Path 7308",
    d: "M100,56h12.668a3.25,3.25,0,0,1,3.25,3.25V70.623a1.625,1.625,0,0,1-1.625,1.625H101.641",
    transform: "translate(-96.752 -56)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7309",
    "data-name": "Path 7309",
    d: "M261.625,142.5A1.625,1.625,0,0,1,260,140.874v-3.25A1.625,1.625,0,0,1,261.625,136h2.923a1.625,1.625,0,0,1,1.625,1.625v3.25a1.625,1.625,0,0,1-1.625,1.625Z",
    transform: "translate(-250.255 -132.752)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_516",
    "data-name": "Line 516",
    x2: 5.989,
    transform: "translate(29.881 68.911)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsletter);
export default __webpack_public_path__ + "static/media/newsletter.3ea5732887d8bf0b5658ab8b93387661.svg";
export { ForwardRef as ReactComponent };